import { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';

export default function PortalComponent({ children }) {
    const ref = useRef(null);
    useEffect(() => {
        ref.current = document.body;
    }, []);
    return ref.current ? createPortal(children, ref.current) : null;
}